import { useEffect } from 'react';
import { buildCanonicalUrl, SEO_DEFAULT_DESCRIPTION, SEO_DEFAULT_IMAGE, SEO_DEFAULT_TITLE } from '../config/seo';

function ensureMeta(selector, attributes) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    Object.entries(attributes).forEach(([key, value]) => {
      element.setAttribute(key, value);
    });
    element.dataset.seoManaged = 'true';
    document.head.appendChild(element);
  }

  return element;
}

function ensureLink(selector, attributes) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('link');
    Object.entries(attributes).forEach(([key, value]) => {
      element.setAttribute(key, value);
    });
    element.dataset.seoManaged = 'true';
    document.head.appendChild(element);
  }

  return element;
}

export default function usePageSeo(config = {}) {
  useEffect(() => {
    const title = config.title || SEO_DEFAULT_TITLE;
    const description = config.description || SEO_DEFAULT_DESCRIPTION;
    const canonical = config.canonical || buildCanonicalUrl(config.path || '/');
    const robots = config.robots || 'index,follow,max-image-preview:large';
    const ogType = config.ogType || 'website';
    const image = config.image || SEO_DEFAULT_IMAGE;

    document.title = title;

    ensureMeta('meta[name="description"]', { name: 'description' }).setAttribute('content', description);
    ensureMeta('meta[name="robots"]', { name: 'robots' }).setAttribute('content', robots);

    ensureLink('link[rel="canonical"]', { rel: 'canonical' }).setAttribute('href', canonical);

    ensureMeta('meta[property="og:title"]', { property: 'og:title' }).setAttribute('content', title);
    ensureMeta('meta[property="og:description"]', { property: 'og:description' }).setAttribute('content', description);
    ensureMeta('meta[property="og:type"]', { property: 'og:type' }).setAttribute('content', ogType);
    ensureMeta('meta[property="og:url"]', { property: 'og:url' }).setAttribute('content', canonical);
    ensureMeta('meta[property="og:image"]', { property: 'og:image' }).setAttribute('content', image);

    ensureMeta('meta[name="twitter:card"]', { name: 'twitter:card' }).setAttribute('content', 'summary_large_image');
    ensureMeta('meta[name="twitter:title"]', { name: 'twitter:title' }).setAttribute('content', title);
    ensureMeta('meta[name="twitter:description"]', { name: 'twitter:description' }).setAttribute('content', description);
    ensureMeta('meta[name="twitter:image"]', { name: 'twitter:image' }).setAttribute('content', image);
  }, [config.canonical, config.description, config.image, config.ogType, config.path, config.robots, config.title]);
}
